
const files = require.context(__dirname, false, /.*\.polyfill.js$/);
files.keys().forEach(files);


// WEBPACK FOOTER //
// ./client/src/site__fus078/polyfills/index.js